import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_TOTAL_REVENUE_BY_FILTER_DASHBOARD } from "../Schema/Dashboard";

const useGetRevenueByFilterDashboard = ({ filterType, date }) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const { refetch } = useQuery(GET_TOTAL_REVENUE_BY_FILTER_DASHBOARD, {
    variables: {
      filterType,
      date,
    },
    onCompleted: ({ getTotalRevenueByFilter }) => {
      setTableData(getTotalRevenueByFilter || []);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [filterType, date]);

  return { tableData, loading };
};

export default useGetRevenueByFilterDashboard;
